import { safeSessionStorage } from './safeStorage';

export const RATING_FLOW_SESSION_LOCK_KEY = 'hzc_rating_flow_session_lock';
export const RATING_FLOW_SESSION_LOCK_EVENT = 'hzc_rating_flow_session_lock_set';

export function setRatingFlowSessionLock(): void {
  safeSessionStorage.setItem(RATING_FLOW_SESSION_LOCK_KEY, '1');
  try {
    window.dispatchEvent(new Event(RATING_FLOW_SESSION_LOCK_EVENT));
  } catch (_) {}
}

export function isRatingFlowSessionLocked(): boolean {
  return safeSessionStorage.getItem(RATING_FLOW_SESSION_LOCK_KEY) === '1';
}
